import { Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import Footer from "./Footer";

export default function Shell() {
  return (
    <div className="flex h-full flex-col">
      <TopBar />
      {/* Content area scrolls; footer is inside so it scrolls with the page */}
      <main
        id="main-content"
        className="flex-1 overflow-y-auto pt-16 scrollbar-thin"
        tabIndex={-1}   // allows "skip to content" focus target
      >
        <div className="flex min-h-full flex-col">
          <div className="flex-1">
            <Outlet />
          </div>
          <Footer />
        </div>
      </main>
    </div>
  );
}
